// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__steps-options__actions--sb-share{display:flex;width:100%!important;max-width:450px!important}#cz2.cz2 .cz2__steps-options__actions--sb-share button{flex:1 1 0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
